<template>
  <div
    style="
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
    "
  >
    <div
      style="flex-grow: 13; overflow-y: auto; height: 100%"
      class="Kanit pa-4"
    >
      <div>
        <h1 style="color: rgb(89, 229, 39); font-size: 25px">
          <span style="color: rgb(70, 70, 70)">
            ข้อตกลง และเงื่อนไข<br />Privacy Policy</span
          >
        </h1>
      </div>
      <div style="text-indent: 1.5em" class="mt-3 mb-2">
        ข้าพเจ้ายินยอมให้มีการเก็บรวบรวม ใช้
        เปิดเผยและ/หรือถ่ายโอนข้อมูลส่วนบุคคลที่ละเอียดอ่อนของข้าพเจ้า
        เพื่อวัตถุประสงค์ที่กฎหมายอนุญาตให้บริษัทฯ (นายจ้าง)
        และบริษัทในกลุ่มเซ็นทรัล
        ตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวของสายงานทรัพยากรบุคคล
      </div>
      <div style="text-indent: 1.5em">
        I consent to the collection /use /disclosure and or transfer of my
        Sensitive Data for the purposes where the consent is required by law to
        the Company (Employer) and Central Group Companies as specified in the
        HR Privacy Policy
      </div>
      <div
        @click="showPDF"
        class="mt-2"
        style="text-indent: 1.5em; color: #ea2e2e; text-decoration: underline"
      >
        อ่านเงื่อนไขการรักษาข้อมูลส่วนบุคคล/please allow if you accept the term
        of privacy comply with PDPA
      </div>
    </div>
    <div style="flex-grow: 2" class="elevation-10 Kanit text-center py-3">
      <v-row dense class="px-2 mx-0">
        <v-col cols="6">
          <v-btn
            @click="cancel"
            outlined
            block
            color="grey"
            class="mr-2"
            dark
            style="font-size: 16px"
            >ยกเลิก/Cancel</v-btn
          ></v-col
        >
        <v-col cols="6">
          <v-btn
            @click="agree"
            block
            depressed
            color="#E91F27"
            dark
            style="font-size: 16px"
            >ยอมรับ/Accept</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    cancel() {
      this.$liff.closeWindow();
    },
    agree() {
      this.$emit("close");
    },
    showPDF() {
      this.$liff.openWindow({
        url: "https://centralretailcareers.com/img/bot/PDPA_HR_SES.pdf",
        external: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>